var it = Object.defineProperty;
var st = (n, t, e) => t in n ? it(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var f = (n, t, e) => st(n, typeof t != "symbol" ? t + "" : t, e);
import * as y from "react";
import q, { createContext as ot, useContext as at, useEffect as ct } from "react";
import { g as lt } from "./_commonjsHelpers-C6fGbg64.js";
const F = /* @__PURE__ */ ot({});
var _ = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var E;
function ht() {
  return E || (E = 1, function(n) {
    (function() {
      var t = {}.hasOwnProperty;
      function e() {
        for (var i = "", o = 0; o < arguments.length; o++) {
          var a = arguments[o];
          a && (i = s(i, r(a)));
        }
        return i;
      }
      function r(i) {
        if (typeof i == "string" || typeof i == "number")
          return i;
        if (typeof i != "object")
          return "";
        if (Array.isArray(i))
          return e.apply(null, i);
        if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
          return i.toString();
        var o = "";
        for (var a in i)
          t.call(i, a) && i[a] && (o = s(o, a));
        return o;
      }
      function s(i, o) {
        return o ? i ? i + " " + o : i + o : i;
      }
      n.exports ? (e.default = e, n.exports = e) : window.classNames = e;
    })();
  }(_)), _.exports;
}
var ut = ht();
const ft = /* @__PURE__ */ lt(ut), gt = {
  aliceblue: "9ehhb",
  antiquewhite: "9sgk7",
  aqua: "1ekf",
  aquamarine: "4zsno",
  azure: "9eiv3",
  beige: "9lhp8",
  bisque: "9zg04",
  black: "0",
  blanchedalmond: "9zhe5",
  blue: "73",
  blueviolet: "5e31e",
  brown: "6g016",
  burlywood: "8ouiv",
  cadetblue: "3qba8",
  chartreuse: "4zshs",
  chocolate: "87k0u",
  coral: "9yvyo",
  cornflowerblue: "3xael",
  cornsilk: "9zjz0",
  crimson: "8l4xo",
  cyan: "1ekf",
  darkblue: "3v",
  darkcyan: "rkb",
  darkgoldenrod: "776yz",
  darkgray: "6mbhl",
  darkgreen: "jr4",
  darkgrey: "6mbhl",
  darkkhaki: "7ehkb",
  darkmagenta: "5f91n",
  darkolivegreen: "3bzfz",
  darkorange: "9yygw",
  darkorchid: "5z6x8",
  darkred: "5f8xs",
  darksalmon: "9441m",
  darkseagreen: "5lwgf",
  darkslateblue: "2th1n",
  darkslategray: "1ugcv",
  darkslategrey: "1ugcv",
  darkturquoise: "14up",
  darkviolet: "5rw7n",
  deeppink: "9yavn",
  deepskyblue: "11xb",
  dimgray: "442g9",
  dimgrey: "442g9",
  dodgerblue: "16xof",
  firebrick: "6y7tu",
  floralwhite: "9zkds",
  forestgreen: "1cisi",
  fuchsia: "9y70f",
  gainsboro: "8m8kc",
  ghostwhite: "9pq0v",
  goldenrod: "8j4f4",
  gold: "9zda8",
  gray: "50i2o",
  green: "pa8",
  greenyellow: "6senj",
  grey: "50i2o",
  honeydew: "9eiuo",
  hotpink: "9yrp0",
  indianred: "80gnw",
  indigo: "2xcoy",
  ivory: "9zldc",
  khaki: "9edu4",
  lavenderblush: "9ziet",
  lavender: "90c8q",
  lawngreen: "4vk74",
  lemonchiffon: "9zkct",
  lightblue: "6s73a",
  lightcoral: "9dtog",
  lightcyan: "8s1rz",
  lightgoldenrodyellow: "9sjiq",
  lightgray: "89jo3",
  lightgreen: "5nkwg",
  lightgrey: "89jo3",
  lightpink: "9z6wx",
  lightsalmon: "9z2ii",
  lightseagreen: "19xgq",
  lightskyblue: "5arju",
  lightslategray: "4nwk9",
  lightslategrey: "4nwk9",
  lightsteelblue: "6wau6",
  lightyellow: "9zlcw",
  lime: "1edc",
  limegreen: "1zcxe",
  linen: "9shk6",
  magenta: "9y70f",
  maroon: "4zsow",
  mediumaquamarine: "40eju",
  mediumblue: "5p",
  mediumorchid: "79qkz",
  mediumpurple: "5r3rv",
  mediumseagreen: "2d9ip",
  mediumslateblue: "4tcku",
  mediumspringgreen: "1di2",
  mediumturquoise: "2uabw",
  mediumvioletred: "7rn9h",
  midnightblue: "z980",
  mintcream: "9ljp6",
  mistyrose: "9zg0x",
  moccasin: "9zfzp",
  navajowhite: "9zest",
  navy: "3k",
  oldlace: "9wq92",
  olive: "50hz4",
  olivedrab: "472ub",
  orange: "9z3eo",
  orangered: "9ykg0",
  orchid: "8iu3a",
  palegoldenrod: "9bl4a",
  palegreen: "5yw0o",
  paleturquoise: "6v4ku",
  palevioletred: "8k8lv",
  papayawhip: "9zi6t",
  peachpuff: "9ze0p",
  peru: "80oqn",
  pink: "9z8wb",
  plum: "8nba5",
  powderblue: "6wgdi",
  purple: "4zssg",
  rebeccapurple: "3zk49",
  red: "9y6tc",
  rosybrown: "7cv4f",
  royalblue: "2jvtt",
  saddlebrown: "5fmkz",
  salmon: "9rvci",
  sandybrown: "9jn1c",
  seagreen: "1tdnb",
  seashell: "9zje6",
  sienna: "6973h",
  silver: "7ir40",
  skyblue: "5arjf",
  slateblue: "45e4t",
  slategray: "4e100",
  slategrey: "4e100",
  snow: "9zke2",
  springgreen: "1egv",
  steelblue: "2r1kk",
  tan: "87yx8",
  teal: "pds",
  thistle: "8ggk8",
  tomato: "9yqfb",
  turquoise: "2j4r4",
  violet: "9b10u",
  wheat: "9ld4j",
  white: "9zldr",
  whitesmoke: "9lhpx",
  yellow: "9zl6o",
  yellowgreen: "61fzm"
}, u = Math.round;
function S(n, t) {
  const e = n.replace(/^[^(]*\((.*)/, "$1").replace(/\).*/, "").match(/\d*\.?\d+%?/g) || [], r = e.map((s) => parseFloat(s));
  for (let s = 0; s < 3; s += 1)
    r[s] = t(r[s] || 0, e[s] || "", s);
  return e[3] ? r[3] = e[3].includes("%") ? r[3] / 100 : r[3] : r[3] = 1, r;
}
const A = (n, t, e) => e === 0 ? n : n / 100;
function p(n, t) {
  const e = t || 255;
  return n > e ? e : n < 0 ? 0 : n;
}
class m {
  constructor(t) {
    /**
     * All FastColor objects are valid. So isValid is always true. This property is kept to be compatible with TinyColor.
     */
    f(this, "isValid", !0);
    /**
     * Red, R in RGB
     */
    f(this, "r", 0);
    /**
     * Green, G in RGB
     */
    f(this, "g", 0);
    /**
     * Blue, B in RGB
     */
    f(this, "b", 0);
    /**
     * Alpha/Opacity, A in RGBA/HSLA
     */
    f(this, "a", 1);
    // HSV privates
    f(this, "_h");
    f(this, "_s");
    f(this, "_l");
    f(this, "_v");
    // intermediate variables to calculate HSL/HSV
    f(this, "_max");
    f(this, "_min");
    f(this, "_brightness");
    function e(r) {
      return r[0] in t && r[1] in t && r[2] in t;
    }
    if (t) if (typeof t == "string") {
      let s = function(i) {
        return r.startsWith(i);
      };
      const r = t.trim();
      if (/^#?[A-F\d]{3,8}$/i.test(r))
        this.fromHexString(r);
      else if (s("rgb"))
        this.fromRgbString(r);
      else if (s("hsl"))
        this.fromHslString(r);
      else if (s("hsv") || s("hsb"))
        this.fromHsvString(r);
      else {
        const i = gt[r.toLowerCase()];
        i && this.fromHexString(
          // Convert 36 hex to 16 hex
          parseInt(i, 36).toString(16).padStart(6, "0")
        );
      }
    } else if (t instanceof m)
      this.r = t.r, this.g = t.g, this.b = t.b, this.a = t.a, this._h = t._h, this._s = t._s, this._l = t._l, this._v = t._v;
    else if (e("rgb"))
      this.r = p(t.r), this.g = p(t.g), this.b = p(t.b), this.a = typeof t.a == "number" ? p(t.a, 1) : 1;
    else if (e("hsl"))
      this.fromHsl(t);
    else if (e("hsv"))
      this.fromHsv(t);
    else
      throw new Error("@ant-design/fast-color: unsupported input " + JSON.stringify(t));
  }
  // ======================= Setter =======================
  setR(t) {
    return this._sc("r", t);
  }
  setG(t) {
    return this._sc("g", t);
  }
  setB(t) {
    return this._sc("b", t);
  }
  setA(t) {
    return this._sc("a", t, 1);
  }
  setHue(t) {
    const e = this.toHsv();
    return e.h = t, this._c(e);
  }
  // ======================= Getter =======================
  /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */
  getLuminance() {
    function t(i) {
      const o = i / 255;
      return o <= 0.03928 ? o / 12.92 : Math.pow((o + 0.055) / 1.055, 2.4);
    }
    const e = t(this.r), r = t(this.g), s = t(this.b);
    return 0.2126 * e + 0.7152 * r + 0.0722 * s;
  }
  getHue() {
    if (typeof this._h > "u") {
      const t = this.getMax() - this.getMin();
      t === 0 ? this._h = 0 : this._h = u(60 * (this.r === this.getMax() ? (this.g - this.b) / t + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / t + 2 : (this.r - this.g) / t + 4));
    }
    return this._h;
  }
  getSaturation() {
    if (typeof this._s > "u") {
      const t = this.getMax() - this.getMin();
      t === 0 ? this._s = 0 : this._s = t / this.getMax();
    }
    return this._s;
  }
  getLightness() {
    return typeof this._l > "u" && (this._l = (this.getMax() + this.getMin()) / 510), this._l;
  }
  getValue() {
    return typeof this._v > "u" && (this._v = this.getMax() / 255), this._v;
  }
  /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */
  getBrightness() {
    return typeof this._brightness > "u" && (this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1e3), this._brightness;
  }
  // ======================== Func ========================
  darken(t = 10) {
    const e = this.getHue(), r = this.getSaturation();
    let s = this.getLightness() - t / 100;
    return s < 0 && (s = 0), this._c({
      h: e,
      s: r,
      l: s,
      a: this.a
    });
  }
  lighten(t = 10) {
    const e = this.getHue(), r = this.getSaturation();
    let s = this.getLightness() + t / 100;
    return s > 1 && (s = 1), this._c({
      h: e,
      s: r,
      l: s,
      a: this.a
    });
  }
  /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */
  mix(t, e = 50) {
    const r = this._c(t), s = e / 100, i = (a) => (r[a] - this[a]) * s + this[a], o = {
      r: u(i("r")),
      g: u(i("g")),
      b: u(i("b")),
      a: u(i("a") * 100) / 100
    };
    return this._c(o);
  }
  /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */
  tint(t = 10) {
    return this.mix({
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, t);
  }
  /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */
  shade(t = 10) {
    return this.mix({
      r: 0,
      g: 0,
      b: 0,
      a: 1
    }, t);
  }
  onBackground(t) {
    const e = this._c(t), r = this.a + e.a * (1 - this.a), s = (i) => u((this[i] * this.a + e[i] * e.a * (1 - this.a)) / r);
    return this._c({
      r: s("r"),
      g: s("g"),
      b: s("b"),
      a: r
    });
  }
  // ======================= Status =======================
  isDark() {
    return this.getBrightness() < 128;
  }
  isLight() {
    return this.getBrightness() >= 128;
  }
  // ======================== MISC ========================
  equals(t) {
    return this.r === t.r && this.g === t.g && this.b === t.b && this.a === t.a;
  }
  clone() {
    return this._c(this);
  }
  // ======================= Format =======================
  toHexString() {
    let t = "#";
    const e = (this.r || 0).toString(16);
    t += e.length === 2 ? e : "0" + e;
    const r = (this.g || 0).toString(16);
    t += r.length === 2 ? r : "0" + r;
    const s = (this.b || 0).toString(16);
    if (t += s.length === 2 ? s : "0" + s, typeof this.a == "number" && this.a >= 0 && this.a < 1) {
      const i = u(this.a * 255).toString(16);
      t += i.length === 2 ? i : "0" + i;
    }
    return t;
  }
  /** CSS support color pattern */
  toHsl() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      l: this.getLightness(),
      a: this.a
    };
  }
  /** CSS support color pattern */
  toHslString() {
    const t = this.getHue(), e = u(this.getSaturation() * 100), r = u(this.getLightness() * 100);
    return this.a !== 1 ? `hsla(${t},${e}%,${r}%,${this.a})` : `hsl(${t},${e}%,${r}%)`;
  }
  /** Same as toHsb */
  toHsv() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      v: this.getValue(),
      a: this.a
    };
  }
  toRgb() {
    return {
      r: this.r,
      g: this.g,
      b: this.b,
      a: this.a
    };
  }
  toRgbString() {
    return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
  }
  toString() {
    return this.toRgbString();
  }
  // ====================== Privates ======================
  /** Return a new FastColor object with one channel changed */
  _sc(t, e, r) {
    const s = this.clone();
    return s[t] = p(e, r), s;
  }
  _c(t) {
    return new this.constructor(t);
  }
  getMax() {
    return typeof this._max > "u" && (this._max = Math.max(this.r, this.g, this.b)), this._max;
  }
  getMin() {
    return typeof this._min > "u" && (this._min = Math.min(this.r, this.g, this.b)), this._min;
  }
  fromHexString(t) {
    const e = t.replace("#", "");
    function r(s, i) {
      return parseInt(e[s] + e[i || s], 16);
    }
    e.length < 6 ? (this.r = r(0), this.g = r(1), this.b = r(2), this.a = e[3] ? r(3) / 255 : 1) : (this.r = r(0, 1), this.g = r(2, 3), this.b = r(4, 5), this.a = e[6] ? r(6, 7) / 255 : 1);
  }
  fromHsl({
    h: t,
    s: e,
    l: r,
    a: s
  }) {
    if (this._h = t % 360, this._s = e, this._l = r, this.a = typeof s == "number" ? s : 1, e <= 0) {
      const d = u(r * 255);
      this.r = d, this.g = d, this.b = d;
    }
    let i = 0, o = 0, a = 0;
    const c = t / 60, h = (1 - Math.abs(2 * r - 1)) * e, l = h * (1 - Math.abs(c % 2 - 1));
    c >= 0 && c < 1 ? (i = h, o = l) : c >= 1 && c < 2 ? (i = l, o = h) : c >= 2 && c < 3 ? (o = h, a = l) : c >= 3 && c < 4 ? (o = l, a = h) : c >= 4 && c < 5 ? (i = l, a = h) : c >= 5 && c < 6 && (i = h, a = l);
    const g = r - h / 2;
    this.r = u((i + g) * 255), this.g = u((o + g) * 255), this.b = u((a + g) * 255);
  }
  fromHsv({
    h: t,
    s: e,
    v: r,
    a: s
  }) {
    this._h = t % 360, this._s = e, this._v = r, this.a = typeof s == "number" ? s : 1;
    const i = u(r * 255);
    if (this.r = i, this.g = i, this.b = i, e <= 0)
      return;
    const o = t / 60, a = Math.floor(o), c = o - a, h = u(r * (1 - e) * 255), l = u(r * (1 - e * c) * 255), g = u(r * (1 - e * (1 - c)) * 255);
    switch (a) {
      case 0:
        this.g = g, this.b = h;
        break;
      case 1:
        this.r = l, this.b = h;
        break;
      case 2:
        this.r = h, this.b = g;
        break;
      case 3:
        this.r = h, this.g = l;
        break;
      case 4:
        this.r = g, this.g = h;
        break;
      case 5:
      default:
        this.g = h, this.b = l;
        break;
    }
  }
  fromHsvString(t) {
    const e = S(t, A);
    this.fromHsv({
      h: e[0],
      s: e[1],
      v: e[2],
      a: e[3]
    });
  }
  fromHslString(t) {
    const e = S(t, A);
    this.fromHsl({
      h: e[0],
      s: e[1],
      l: e[2],
      a: e[3]
    });
  }
  fromRgbString(t) {
    const e = S(t, (r, s) => (
      // Convert percentage to number. e.g. 50% -> 128
      s.includes("%") ? u(r / 100 * 255) : r
    ));
    this.r = e[0], this.g = e[1], this.b = e[2], this.a = e[3];
  }
}
const x = 2, O = 0.16, dt = 0.05, mt = 0.05, bt = 0.15, Q = 5, G = 4, pt = [{
  index: 7,
  amount: 15
}, {
  index: 6,
  amount: 25
}, {
  index: 5,
  amount: 30
}, {
  index: 5,
  amount: 45
}, {
  index: 5,
  amount: 65
}, {
  index: 5,
  amount: 85
}, {
  index: 4,
  amount: 90
}, {
  index: 3,
  amount: 95
}, {
  index: 2,
  amount: 97
}, {
  index: 1,
  amount: 98
}];
function I(n, t, e) {
  let r;
  return Math.round(n.h) >= 60 && Math.round(n.h) <= 240 ? r = e ? Math.round(n.h) - x * t : Math.round(n.h) + x * t : r = e ? Math.round(n.h) + x * t : Math.round(n.h) - x * t, r < 0 ? r += 360 : r >= 360 && (r -= 360), r;
}
function L(n, t, e) {
  if (n.h === 0 && n.s === 0)
    return n.s;
  let r;
  return e ? r = n.s - O * t : t === G ? r = n.s + O : r = n.s + dt * t, r > 1 && (r = 1), e && t === Q && r > 0.1 && (r = 0.1), r < 0.06 && (r = 0.06), Math.round(r * 100) / 100;
}
function P(n, t, e) {
  let r;
  return e ? r = n.v + mt * t : r = n.v - bt * t, r = Math.max(0, Math.min(1, r)), Math.round(r * 100) / 100;
}
function yt(n, t = {}) {
  const e = [], r = new m(n), s = r.toHsv();
  for (let i = Q; i > 0; i -= 1) {
    const o = new m({
      h: I(s, i, !0),
      s: L(s, i, !0),
      v: P(s, i, !0)
    });
    e.push(o);
  }
  e.push(r);
  for (let i = 1; i <= G; i += 1) {
    const o = new m({
      h: I(s, i),
      s: L(s, i),
      v: P(s, i)
    });
    e.push(o);
  }
  return t.theme === "dark" ? pt.map(({
    index: i,
    amount: o
  }) => new m(t.backgroundColor || "#141414").mix(e[i], o).toHexString()) : e.map((i) => i.toHexString());
}
const v = ["#e6f4ff", "#bae0ff", "#91caff", "#69b1ff", "#4096ff", "#1677ff", "#0958d9", "#003eb3", "#002c8c", "#001d66"];
v.primary = v[5];
function wt() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function xt(n, t) {
  if (!n)
    return !1;
  if (n.contains)
    return n.contains(t);
  let e = t;
  for (; e; ) {
    if (e === n)
      return !0;
    e = e.parentNode;
  }
  return !1;
}
const B = "data-rc-order", D = "data-rc-priority", kt = "rc-util-key", z = /* @__PURE__ */ new Map();
function Y({
  mark: n
} = {}) {
  return n ? n.startsWith("data-") ? n : `data-${n}` : kt;
}
function T(n) {
  return n.attachTo ? n.attachTo : document.querySelector("head") || document.body;
}
function Ct(n) {
  return n === "queue" ? "prependQueue" : n ? "prepend" : "append";
}
function j(n) {
  return Array.from((z.get(n) || n).children).filter((t) => t.tagName === "STYLE");
}
function K(n, t = {}) {
  if (!wt())
    return null;
  const {
    csp: e,
    prepend: r,
    priority: s = 0
  } = t, i = Ct(r), o = i === "prependQueue", a = document.createElement("style");
  a.setAttribute(B, i), o && s && a.setAttribute(D, `${s}`), e != null && e.nonce && (a.nonce = e == null ? void 0 : e.nonce), a.innerHTML = n;
  const c = T(t), {
    firstChild: h
  } = c;
  if (r) {
    if (o) {
      const l = (t.styles || j(c)).filter((g) => {
        if (!["prepend", "prependQueue"].includes(g.getAttribute(B)))
          return !1;
        const d = Number(g.getAttribute(D) || 0);
        return s >= d;
      });
      if (l.length)
        return c.insertBefore(a, l[l.length - 1].nextSibling), a;
    }
    c.insertBefore(a, h);
  } else
    c.appendChild(a);
  return a;
}
function _t(n, t = {}) {
  let {
    styles: e
  } = t;
  return e || (e = j(T(t))), e.find((r) => r.getAttribute(Y(t)) === n);
}
function St(n, t) {
  const e = z.get(n);
  if (!e || !xt(document, e)) {
    const r = K("", t), {
      parentNode: s
    } = r;
    z.set(n, s), n.removeChild(r);
  }
}
function vt(n, t, e = {}) {
  var c, h, l;
  const r = T(e), s = j(r), i = {
    ...e,
    styles: s
  };
  St(r, i);
  const o = _t(t, i);
  if (o)
    return (c = i.csp) != null && c.nonce && o.nonce !== ((h = i.csp) == null ? void 0 : h.nonce) && (o.nonce = (l = i.csp) == null ? void 0 : l.nonce), o.innerHTML !== n && (o.innerHTML = n), o;
  const a = K(n, i);
  return a.setAttribute(Y(i), t), a;
}
function U(n) {
  var t;
  return (t = n == null ? void 0 : n.getRootNode) == null ? void 0 : t.call(n);
}
function zt(n) {
  return U(n) instanceof ShadowRoot;
}
function Mt(n) {
  return zt(n) ? U(n) : null;
}
let M = {};
const N = [], Ht = (n) => {
  N.push(n);
};
function $t(n, t) {
  if (process.env.NODE_ENV !== "production" && !n && console !== void 0) {
    const e = N.reduce((r, s) => s(r ?? "", "warning"), t);
    e && console.error(`Warning: ${e}`);
  }
}
function Tt(n, t) {
  if (process.env.NODE_ENV !== "production" && !n && console !== void 0) {
    const e = N.reduce((r, s) => s(r ?? "", "note"), t);
    e && console.warn(`Note: ${e}`);
  }
}
function jt() {
  M = {};
}
function J(n, t, e) {
  !t && !M[e] && (n(!1, e), M[e] = !0);
}
function k(n, t) {
  J($t, n, t);
}
function Nt(n, t) {
  J(Tt, n, t);
}
k.preMessage = Ht;
k.resetWarned = jt;
k.noteOnce = Nt;
function Rt(n) {
  return n.replace(/-(.)/g, (t, e) => e.toUpperCase());
}
function qt(n, t) {
  k(n, `[@ant-design/icons] ${t}`);
}
function V(n) {
  return typeof n == "object" && typeof n.name == "string" && typeof n.theme == "string" && (typeof n.icon == "object" || typeof n.icon == "function");
}
function W(n = {}) {
  return Object.keys(n).reduce((t, e) => {
    const r = n[e];
    switch (e) {
      case "class":
        t.className = r, delete t.class;
        break;
      default:
        delete t[e], t[Rt(e)] = r;
    }
    return t;
  }, {});
}
function H(n, t, e) {
  return e ? /* @__PURE__ */ q.createElement(n.tag, {
    key: t,
    ...W(n.attrs),
    ...e
  }, (n.children || []).map((r, s) => H(r, `${t}-${n.tag}-${s}`))) : /* @__PURE__ */ q.createElement(n.tag, {
    key: t,
    ...W(n.attrs)
  }, (n.children || []).map((r, s) => H(r, `${t}-${n.tag}-${s}`)));
}
function X(n) {
  return yt(n)[0];
}
function Z(n) {
  return n ? Array.isArray(n) ? n : [n] : [];
}
const Et = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, At = (n) => {
  const {
    csp: t,
    prefixCls: e,
    layer: r
  } = at(F);
  let s = Et;
  e && (s = s.replace(/anticon/g, e)), r && (s = `@layer ${r} {
${s}
}`), ct(() => {
    const i = n.current, o = Mt(i);
    vt(s, "@ant-design-icons", {
      prepend: !r,
      csp: t,
      attachTo: o
    });
  }, []);
}, w = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function Ot({
  primaryColor: n,
  secondaryColor: t
}) {
  w.primaryColor = n, w.secondaryColor = t || X(n), w.calculated = !!t;
}
function It() {
  return {
    ...w
  };
}
const b = (n) => {
  const {
    icon: t,
    className: e,
    onClick: r,
    style: s,
    primaryColor: i,
    secondaryColor: o,
    ...a
  } = n, c = y.useRef();
  let h = w;
  if (i && (h = {
    primaryColor: i,
    secondaryColor: o || X(i)
  }), At(c), qt(V(t), `icon should be icon definiton, but got ${t}`), !V(t))
    return null;
  let l = t;
  return l && typeof l.icon == "function" && (l = {
    ...l,
    icon: l.icon(h.primaryColor, h.secondaryColor)
  }), H(l.icon, `svg-${l.name}`, {
    className: e,
    onClick: r,
    style: s,
    "data-icon": l.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    ...a,
    ref: c
  });
};
b.displayName = "IconReact";
b.getTwoToneColors = It;
b.setTwoToneColors = Ot;
function tt(n) {
  const [t, e] = Z(n);
  return b.setTwoToneColors({
    primaryColor: t,
    secondaryColor: e
  });
}
function Lt() {
  const n = b.getTwoToneColors();
  return n.calculated ? [n.primaryColor, n.secondaryColor] : n.primaryColor;
}
function $() {
  return $ = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var r in e)
        Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
    }
    return n;
  }, $.apply(this, arguments);
}
tt(v.primary);
const R = /* @__PURE__ */ y.forwardRef((n, t) => {
  const {
    // affect outter <i>...</i>
    className: e,
    // affect inner <svg>...</svg>
    icon: r,
    spin: s,
    rotate: i,
    tabIndex: o,
    onClick: a,
    // other
    twoToneColor: c,
    ...h
  } = n, {
    prefixCls: l = "anticon",
    rootClassName: g
  } = y.useContext(F), d = ft(g, l, {
    [`${l}-${r.name}`]: !!r.name,
    [`${l}-spin`]: !!s || r.name === "loading"
  }, e);
  let C = o;
  C === void 0 && a && (C = -1);
  const et = i ? {
    msTransform: `rotate(${i}deg)`,
    transform: `rotate(${i}deg)`
  } : void 0, [nt, rt] = Z(c);
  return /* @__PURE__ */ y.createElement("span", $({
    role: "img",
    "aria-label": r.name
  }, h, {
    ref: t,
    tabIndex: C,
    onClick: a,
    className: d
  }), /* @__PURE__ */ y.createElement(b, {
    icon: r,
    primaryColor: nt,
    secondaryColor: rt,
    style: et
  }));
});
R.displayName = "AntdIcon";
R.getTwoToneColor = Lt;
R.setTwoToneColor = tt;
export {
  R as I
};
